import { css } from '@emotion/css';

export const modalStyles = css`
  width: 58rem;
`;
